/**
 * Enum for project data types and their corresponding table names.
 */
enum ProjectDataTypes {
  UNKNOWN = 'unknown',
  TRACKING = 'tracking',
  METADATA = 'metadata',
  EVENTS = 'events',
  SKELETAL = 'skeletal'
}

/**
 * Map project data types to their respective table names
 */
export const ProjectDataTypeTableMap = {
  [ProjectDataTypes.UNKNOWN]: null,
  [ProjectDataTypes.TRACKING]: 'project_tracking_data',
  [ProjectDataTypes.METADATA]: 'project_meta_data',
  [ProjectDataTypes.EVENTS]: 'project_event_data',
  [ProjectDataTypes.SKELETAL]: 'project_skeletal_data'
} as const;

export default ProjectDataTypes; 